import { Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

const defaultTableStyle = {
  display: "grid",
  alignItems: "center",
  ".MuiInputBase-root": {
    padding: "7px",
    svg: {
      marginRight: "0px",
    },
  },
  ".MuiFormControl-root, .MuiInputBase-root": {
    height: "100%",
  },
  ".MuiInputBase-root, input": {
    borderRadius: 0,
    backgroundColor: "transparent !important",
  },
};

export const StyledBoxStack = styled(Stack, {
    shouldForwardProp: (prop) => !["highlight", "disableBorder"].includes(prop),
})(({ theme, highlight, disableBorder }) => ({
    gridTemplateColumns: `auto repeat(3, 100px) 25px`,
    ...(disableBorder
        ? {}
        : {
            borderBottom: "1px solid",
            borderRight: "1px solid",
            borderLeft: "1px solid",
            borderColor:
                theme.palette.hubColors[highlight ? "mainFocusLight" : "greyLight"],
        }),
    ...(highlight ? {} : { backgroundColor: theme.palette.hubColors.white }),
    ":hover": {
        backgroundColor:
            theme.palette.hubColors[highlight ? "mainFocusLightest" : "greyLightest"],
    },
    fieldset: {
        borderWidth: 0.5,
        borderColor:
            theme.palette.hubColors[highlight ? "mainFocusLight" : "greyLight"],
        ...(highlight
            ? { backgroundColor: theme.palette.hubColors.mainFocusLighter2 }
            : {}),
    },
    ...defaultTableStyle,
}));